/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonGroup, Box } from '@mui/material';
import { HeaderStyles } from './headerStyles';
import slices from '../../state/slices/data';

export default function Header() {
  const dispatch = useDispatch();
  const { setAverage } = slices.actions;
  const average = useSelector((state) => state.data.average);

  function jumpTo(a) {
    dispatch(setAverage(a));
  }

  const averageText =
    average === 'median' ? 'Median employee income' : 'Mean employee income';
  /*
    ['#9e0142','#d53e4f','#f46d43','#fdae61','#fee08b','#ffffbf','#e6f598','#abdda4','#66c2a5','#3288bd','#5e4fa2', '#4c407f', '#3a315e', '#29233f', '#191522', '#000000' 
    */
  const style1 = { backgroundColor: '#9e0142' };
  const style2 = { backgroundColor: '#d53e4f' };
  const style3 = { backgroundColor: '#f46d43' };
  const style4 = { backgroundColor: '#fdae61' };
  const style5 = { backgroundColor: '#fee08b' };
  const style6 = { backgroundColor: '#ffffbf' };
  const style7 = { backgroundColor: '#e6f598' };
  const style8 = { backgroundColor: '#abdda4' };
  const style9 = { backgroundColor: '#66c2a5' };
  const style10 = { backgroundColor: '#3288bd' };
  const style11 = { backgroundColor: '#5e4fa2' };
  const style12 = { backgroundColor: '#4c407f' };
  const style13 = { backgroundColor: '#3a315e' };
  const style14 = { backgroundColor: '#29233f' };
  const style15 = { backgroundColor: '#000000' };

  return (
    <HeaderStyles>
      <div className="headline">Average employee income in Australia</div>
      <p>
        This map compares <strong>median</strong> and <strong>mean</strong>{' '}
        employee incomes across Australia&apos;s SA2 regions to reveal how
        earnings are distributed at a local level. The gap between the two
        measures can signal income inequality, showing where a small number of
        high earners push the average above what most people take home.
      </p>
      <p>
        <strong>Median</strong> income represents the middle point in a
        region&apos;s earnings, while <strong>mean</strong> income is the simple
        average.
      </p>
      <p>
        Tap or click any area to see its figures, and use the toggle buttons to
        flip between median and mean views.
      </p>
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          marginTop: '20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <ButtonGroup
          variant="contained"
          size="small"
          aria-label="Viewport presets"
        >
          <Button onClick={() => jumpTo('median')}>Median</Button>
          <Button onClick={() => jumpTo('mean')}>Mean</Button>
        </ButtonGroup>
      </Box>
      <div className="key-wrap">
        <div className="key-heading">{averageText}</div>
        <div className="key-text-wrap">
          <div className="key-text">$10k</div>
          <div className="key-text" />
          <div className="key-text"></div>
          <div className="key-text"></div>
          <div className="key-text">$50k</div>
          <div className="key-text"></div>
          <div className="key-text"></div>
          <div className="key-text"></div>
          <div className="key-text"></div>
          <div className="key-text">$100k</div>
          <div className="key-text"></div>
          <div className="key-text"></div>
          <div className="key-text"></div>
          <div className="key-text-dbl">$150k+</div>
        </div>
        <div className="key-colours-wrap">
          <div className="key-colour" style={style1} />
          <div className="key-colour" style={style2} />
          <div className="key-colour" style={style3} />
          <div className="key-colour" style={style4} />
          <div className="key-colour" style={style5} />
          <div className="key-colour" style={style6} />
          <div className="key-colour" style={style7} />
          <div className="key-colour" style={style8} />
          <div className="key-colour" style={style9} />
          <div className="key-colour" style={style10} />
          <div className="key-colour" style={style11} />
          <div className="key-colour" style={style12} />
          <div className="key-colour" style={style13} />
          <div className="key-colour" style={style14} />
          <div className="key-colour" style={style15} />
        </div>
      </div>
    </HeaderStyles>
  );
}
